var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.clients),function(c){return _c('li',{key:c._key},[_vm._v(" "+_vm._s(c.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }